var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253.81 253.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c7c7c7;}.cls-2,.cls-3{fill:none;stroke:#c7c7c7;stroke-miterlimit:10;}.cls-2{stroke-width:16.13px;}.cls-3{stroke-width:2.54px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Border",
    className: "cls-1",
    d: "M180.62,0H73.19A73.19,73.19,0,0,0,0,73.19V180.62a73.19,73.19,0,0,0,73.19,73.19H180.62a73.19,73.19,0,0,0,73.19-73.19V73.19A73.19,73.19,0,0,0,180.62,0ZM231,180.13a51,51,0,0,1-51,51H73.7a51,51,0,0,1-51-51V73.79a51,51,0,0,1,51-51H180a51,51,0,0,1,51,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Planet",
    className: "cls-1",
    d: "M126.88,62.09A64.89,64.89,0,1,0,191.76,127,64.89,64.89,0,0,0,126.88,62.09Zm0,107.3a42.41,42.41,0,1,1,42.4-42.4A42.4,42.4,0,0,1,126.87,169.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Star_1",
    "data-name": "Star 1",
    className: "cls-1",
    cx: 186.9,
    cy: 51.78,
    r: 12.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ring",
    className: "cls-2",
    d: "M72.14,128.47c-16.85,12.27-26,24.19-22.76,31.78,5.53,12.88,44.71,8.43,87.53-9.94s73-43.71,67.52-56.59c-3.33-7.76-18.88-9.23-40.08-5.15"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Star_2",
    "data-name": "Star 2",
    className: "cls-3",
    cx: 159.42,
    cy: 49.43,
    r: 4.01
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.47d47fcd5a362b0ce985969b180b622b.svg";
export { ForwardRef as ReactComponent };